<!-- Rooms Display -->
@if (booking && booking.flats && booking.flats.length > 0) {
  @for (flat of booking.flats; track flat.id) {
    <app-booking-room-display [flat]="flat"></app-booking-room-display>
  }
} @else {
  <div class="surface-card border-round shadow-2 p-4">
    <div class="text-center text-gray-500">
      <i class="pi pi-home mb-3 text-4xl"></i>
      <h3 class="mb-2 text-lg font-medium">{{ 'booking.detail.rooms.noRooms' | translate }}</h3>
      <p>{{ 'booking.detail.rooms.noRoomsDescription' | translate }}</p>
    </div>
  </div>
}
